<div class="role-selection-content">
    <div *ngIf="roles.length" class="role-selection-block">
        <div class="welcome-message">Welcome, {{ user.name }}</div>
        <!-- <div class="title">Select Your Role</div> -->
        <div class="suggestion-text">Choose a role to access the application</div>
        <div class="role-options">
            <label for="role-select" class="role-label">Available Roles:</label>
            <select id="role-select" class="role-select" [(ngModel)]="selectedRole">
                <option value="" disabled selected hidden>Select a role</option>
                <option *ngFor="let role of roles" [value]="role">{{ role }}</option>
            </select>
        </div>
        <div class="actions">
            <button class="btn secondary" (click)="logout()">Logout</button>
            <button class="btn primary" (click)="setRole()" [disabled]="!selectedRole">Enter</button>
        </div>
    </div>
    <div *ngIf="!roles.length" class="no-role-block">
        <div class="welcome-message">Welcome, {{ user.name }}</div>
        <div class="no-roles-message">No role is assigned to you</div>
        <div class="suggestion-text">Kindly contact your administrator to assign a role</div>
        <div class="actions no-role-actions">
            <button class="btn secondary" (click)="logout()">Logout</button>
        </div>
    </div>
</div>
